export default "/assets/webshop/img/logo.png?c128abc302e440c2c27ceb303ac39ab0";